import { cn } from '~/DesignSystem/lib/utils'

type LayoutProps = React.ComponentProps<'div'>

export function Layout({ className, ...props }: LayoutProps) {
  return <div className={cn('flex', 'flex-col', 'h-dvh', 'bg-background', className)} {...props} />
}

export function LayoutContent({ className, ...props }: LayoutProps) {
  return <div className={cn('flex-1 p-4 min-h-0', className)} {...props} />
}

export function LayoutFooter({ className, ...props }: LayoutProps) {
  return <div className={cn('p-4 border-t', className)} {...props} />
}
